// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__uxVfR","quotation_container":"admin_console_quotation_container__socsU","areas_container":"admin_console_areas_container__wPw6+"};